<template>
  <div>
    <h4 class="mb-4">Mot de passe oublie</h4>
    <div v-if="sent" class="mb-4">Un email a ete envoye a {{ mail }} pour changer votre mot de passe</div>
    <b-form @submit.stop.prevent @submit="sendMail" v-else>
      <b-form-group label="Email">
        <b-form-input v-model="mail" type="email" required></b-form-input>
      </b-form-group>
      <b-btn type="submit" class="fa-pull-right" variant="primary" v-if="!sent">Envoyer</b-btn>
    </b-form>
    <b-btn variant="outline-primary" @click="$router.push('/inscription')">Retour</b-btn>
  </div>
</template>

<script>
import {Auth} from "@/js/caller";

export default {
  name: "RequestPassword",
  data() {
    return {
      mail: "",
      sent: false
    }
  },
  methods: {
    sendMail($event) {
      $event.preventDefault();
      Auth.RequestPassword(this.mail).then(() => {
        console.log("sent");
        this.sent = true;
      });
    },
  }
}
</script>

<style scoped>

</style>